"use client";

import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ManagementRightsOptions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const faqs = [{
    id: "1",
    question: "How do I access my personal data?",
    answer: "You can request a copy of your personal data by contacting our support team. We will provide you with a comprehensive report of all data we hold about you within 30 days of your request."
  }, {
    id: "2",
    question: "Can I update or correct my information?",
    answer: "Yes, you have the right to update or correct any inaccurate personal information. Simply log into your account settings or contact our support team to make the necessary changes."
  }, {
    id: "3",
    question: "How do I delete my account and data?",
    answer: "You can request account deletion at any time. Navigate to your account settings and select 'Delete Account', or contact our support team. Please note that some data may be retained for legal compliance purposes."
  }, {
    id: "4",
    question: "What data do you collect and why?",
    answer: "We collect necessary information to provide our services, including contact details, usage data, and preferences. This data helps us improve your experience and ensure service quality. Full details are available in our Privacy Policy."
  }, {
    id: "5",
    question: "How can I opt-out of marketing communications?",
    answer: "You can unsubscribe from marketing emails by clicking the 'Unsubscribe' link at the bottom of any marketing email, or by adjusting your communication preferences in your account settings."
  }, {
    id: "6",
    question: "Do you share my data with third parties?",
    answer: "We only share your data with trusted service providers who help us operate our platform. We never sell your personal information. All third parties are bound by strict confidentiality agreements."
  }, {
    id: "7",
    question: "How long do you retain my data?",
    answer: "We retain your data for as long as your account is active or as needed to provide services. After account deletion, some data may be retained for legal, security, or business purposes as outlined in our retention policy."
  }];
  return;
}